import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';
import { useBroadcasts } from '../contexts/BroadcastsContext';

export function useUnreadCount() {
  const { currentUser } = useAuth();
  const { inboxBroadcasts } = useBroadcasts();
  const [notifCount, setNotifCount] = useState(0);

  useEffect(() => {
    if (!currentUser) return;
    const q = query(
      collection(db, 'notifications'),
      where('uid', '==', currentUser.uid),
      where('read', '==', false)
    );
    return onSnapshot(q, snap => setNotifCount(snap.size));
  }, [currentUser]);

  return { unreadCount: notifCount + inboxBroadcasts.length };
}
